import { ICON__trash_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';

interface PROPS {
  field: FIELD__list_image_asset;
}

export function G_GRAPH__BUTTON__list_images_clear({ field }: PROPS) {
  /*
   * STORE
   */
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   * EVENTS
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let graph_new = generation_current.tool.graph.clone();

    let field_new = field.clone();

    let edges = graph_new.edges__get_related_to_fields(field_new.items);
    graph_new.edges__delete(edges);

    field_new.items.length = 0;

    await UTILS__graph_data.update_field(graph_new, field_new);
  }

  /*
   * METHODS
   */
  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */
  if (!field.is_ready_for_manual_edit()) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;
  if (field.items.is_empty()) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />; //nothing to clear

  return (
    <UI_PRIMITIVE__button size={'square-6'} disabled={is_disabled()} variant={'no-border-on-bar'} {...{ onClick }} title="Clear image">
      <ICON__trash_solid className="!size-3" />
    </UI_PRIMITIVE__button>
  );
}
